import React, { useId } from 'react';
import {
  CButton, CFormInput, CFormLabel, CModal, CModalBody,
  CModalFooter, CModalHeader, CModalTitle,
} from '@coreui/react';
import './OptionConfigurationModal.css';

// Question entry for option configuration only; independent of assessment titles.
const OptionQuestionModal = ({ visible, isEditing, question, onQuestionChange, onSave, onClose, fieldLabel = 'Question', placeholder = 'Enter question here' }) => {
  const inputId = useId();
  const canSave = Boolean(question?.trim());

  return (
    <CModal className="custom-form-builder-theme__editor-modal option-entry-modal" size="lg" backdrop="static" visible={visible} onClose={onClose}>
      <CModalHeader>
        <CModalTitle>{`${isEditing ? 'Edit' : 'Add'} ${fieldLabel}`}</CModalTitle>
      </CModalHeader>
      <form onSubmit={(event) => {
        event.preventDefault();
        if (canSave) onSave();
      }}>
        <CModalBody>
          <CFormLabel htmlFor={inputId}>{fieldLabel}</CFormLabel>
          <CFormInput
            id={inputId}
            name={fieldLabel.toLowerCase()}
            value={question ?? ''}
            onChange={(event) => onQuestionChange(event.target.value)}
            placeholder={placeholder}
            autoFocus
          />
        </CModalBody>
        <CModalFooter>
          <CButton type="button" color="secondary" className="ui-action-btn ui-action-btn--secondary" onClick={onClose}>Close</CButton>
          <CButton type="submit" color="primary" className="ui-action-btn ui-action-btn--primary" disabled={!canSave}>Save</CButton>
        </CModalFooter>
      </form>
    </CModal>
  );
};

export default OptionQuestionModal;
